/* csp.icon.svg.js */

module.exports = {
    icon: `<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path class="foreground-gl" d="M14.3438 0.84375C6.87075 0.84375 0.805664 6.90884 0.805664 14.3819C0.805664 21.8549 6.87075 27.92 14.3438 27.92C21.8169 27.92 27.882 21.8549 27.882 14.3819C27.882 6.90884 21.8169 0.84375 14.3438 0.84375ZM20.436 19.7972H8.92855C6.68122 19.7972 4.86711 17.983 4.86711 15.7357C4.86711 13.4884 6.68122 11.6743 8.92855 11.6743L9.11809 11.6878C9.71376 9.34571 11.8122 7.61282 14.3438 7.61282C17.3357 7.61282 19.7591 10.0361 19.7591 13.0281H20.436C22.3042 13.0281 23.8205 14.5444 23.8205 16.4126C23.8205 18.2809 22.3042 19.7972 20.436 19.7972Z" fill="#5D6F80"/>
  </svg>  
    `
};
